
export const sortLastInteractionDates = (rowA, rowB, id, desc) => {
    //depending upon the type of sort (asc/desc), for missing values of lastInteractionDate, sort them out so they appear last in the table on sorting - manoj
    const epochOrFuture = (desc) ? (new Date()?.setDate(new Date()?.getDate() + 1)) : new Date('January 1, 1970')?.getTime(); //used when NaN or undefined or missing.
    const rowALastInteractionDate = rowA?.original?.lastInteractionDate?.toDate()?.getTime() || epochOrFuture;
    const rowBLastInteractionDate = rowB?.original?.lastInteractionDate?.toDate()?.getTime() || epochOrFuture;
    
    return (rowBLastInteractionDate - rowALastInteractionDate);
  }; 